export const getDate = (isoString) => {
  if (!isoString) return
  return isoString.split('T')[0]
}

interface IDivision {
  amount: number
  name: Intl.RelativeTimeFormatUnit
}

const DIVISIONS: IDivision[] = [
  { amount: 60, name: 'seconds' },
  { amount: 60, name: 'minutes' },
  { amount: 24, name: 'hours' },
  { amount: 7, name: 'days' },
  { amount: 4.34524, name: 'weeks' },
  { amount: 12, name: 'months' },
  { amount: Number.POSITIVE_INFINITY, name: 'years' }
]

export const formatRelativeDate = (toDate: Date, fromDate = new Date()) => {
  let duration = (+toDate - +fromDate) / 1000

  for (let i = 0; i <= DIVISIONS.length; i += 1) {
    const division = DIVISIONS[i]
    if (Math.abs(duration) < division.amount) {
      const relativeDate = new Intl.RelativeTimeFormat(undefined, {
        numeric: 'auto'
      })
      return relativeDate.format(Math.round(duration), division.name)
    }
    duration /= division.amount
  }
}

export const formatDateToLocale = (isoDate) => {
  return new Date(isoDate).toLocaleString('en-GB', {
    hourCycle: 'h12'
  })
}

export const formatServerTimeToClient = (serverTime) => {
  const d = new Date()
  const tzDiff = serverTime.getTimezoneOffset()
  return new Date(d + tzDiff)
}

export const changeMonth = (inputMth: Date, months: number) => {
  const prevMth = inputMth.getMonth()
  inputMth.setMonth(inputMth.getMonth() + months)
  if (inputMth.getMonth() == prevMth) inputMth.setDate(0)
  return inputMth
}
